import api from './api';

export function getGroups() {
  return api.get('/api/v2/groups');
}

export function addGroup(group) {
  return api.post('/api/v2/groups', group);
}

export function updateGroup(group) {
  return api.put(`/api/v2/groups/${group.id}`, group);
}

export function deleteGroup(group) {
  return api.delete(`/api/v2/groups/${group.id}`);
}
